// extracted by mini-css-extract-plugin
export default {"normalMd":"styles_normalMd__aHeEw","normalSm":"styles_normalSm__jGz8R"};